import { Box, PaxSidebarFlushContent } from "@ncino/pax-ui";

interface DashboardLayoutProps {
  readonly children?: React.ReactNode;
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
  return (
    <PaxSidebarFlushContent
      sx={{
        bgcolor: "background.default",
        minHeight: "100vh",
        width: "100%",
        overflowX: "auto",
      }}
    >
      {children}
    </PaxSidebarFlushContent>
  );
}
